import React, { useRef } from "react";
import menuBarIcon from "../assets/menu-bar.svg";
import { useOutletContext } from "react-router-dom";
import DeployTrigger from "./DeployTrigger";
import { useAuth } from "../context/AuthContext";

export default function PageHeader({ children, pageTitle, is_deploy_enable = true }) {
    const outlet = useOutletContext();
    const { user } = useAuth();
    const toggleSidebar = outlet?.toggleSidebar;


    return (
        <div className="page-header" >
            <div className="page-title-box">
                <button className="btn mob-menu d-mobile-only" onClick={() => toggleSidebar?.()}>
                    <img src={menuBarIcon} alt="menu" />
                </button>
                <h1 className="page-title">{pageTitle}</h1>
            </div>
            <div className="header-btn-group ms-auto">
                {user?.is_deploy_enable && is_deploy_enable && <DeployTrigger />}
                {children}
            </div>
        </div>
    );
}
